export const PersonType = {
    FISICA: "FISICA",
    JURIDICA: "JURIDICA",
    ESTRANGEIRA: "ESTRANGEIRA",
}